import { useMutation } from '@tanstack/react-query';
import { createSubareaRequest } from '../requests/createSubareaRequest';
import { useNavigate } from 'react-router-dom';
import { SubareaFormProps } from '../types/subarea.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useCreateSubarea() {
	const navigate = useNavigate();

	const createSubarea = useMutation({
		mutationFn: async (data: SubareaFormProps) => {
			return createSubareaRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully created!', type: 'success' });
			queryClient.invalidateQueries(['SUBAREA_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
			queryClient.invalidateQueries(['SUBAREA_LIST']);
		},
	});

	return { createSubarea };
}
